import { ChevronLeft, ChevronRight } from "lucide-react";
import { IconButton, cn } from "../ui";

/**
 * CalendarToolbar — moves a calendar view through its periods (a year here; a month or week on a schedule view) and
 * holds the view's own filters in a slot. It owns no data and no filter meaning: the page says what a period is,
 * whether the neighbouring one can be opened, and what the filters do.
 */
export default function CalendarToolbar({
  label,
  periodName = "period",
  onPrevious,
  onNext,
  canPrevious = true,
  canNext = true,
  children,
  className,
}) {
  return (
    <div data-ui="calendar-toolbar" className={cn("flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:gap-3", className)}>
      <div className="flex items-center gap-1" role="group" aria-label={`Choose the ${periodName}`}>
        <IconButton icon={ChevronLeft} label={`Previous ${periodName}`} variant="secondary" size="sm" disabled={!canPrevious} onClick={onPrevious} />
        <p aria-live="polite" className="min-w-[4.5rem] px-1 text-center text-panel-title tabular-nums text-foreground">{label}</p>
        <IconButton icon={ChevronRight} label={`Next ${periodName}`} variant="secondary" size="sm" disabled={!canNext} onClick={onNext} />
      </div>
      {children ? <div className="grid grid-cols-2 gap-2 sm:ml-auto sm:flex sm:items-center">{children}</div> : null}
    </div>
  );
}
